import AtomicBlockIdentifiers from "../AtomicBlockIdentifiers";

const blockIdentifiers = [
  AtomicBlockIdentifiers.YOUTUBE_VIDEO,
  AtomicBlockIdentifiers.IMAGE,
];

/**
 * @param   {EditorState} editorState
 * @returns {Boolean}
 */
export default function isEditorStateEmpty(editorState) {
  return !editorState
    .getCurrentContent()
    .getBlocksAsArray()
    .some(block => {
      const isContentBlock =
        block.getType() === "atomic" &&
        blockIdentifiers.includes(block.getData().get("blockType"));

      if (isContentBlock) {
        return true;
      } else {
        return block.getText().length > 0;
      }
    });
}
